import React, { useEffect, useState } from "react";
import Chart from 'react-apexcharts';
import '../../cssfiles/homepage.css';

const linechartoptions = {
    chart: {
        type: "line",
        toolbar: {
            show: false
        },
        offsetX: 0
    },
    grid: {
        show: true,
        borderColor: 'var(--grey-variation)',
    },
    stroke: {
        show: true,
        //width: [...widthPropertiesLines],
        //curve: [...curvePropertiesLines],
    },
    fill: {
        opacity: 1,
        type: 'solid',
    },
    //colors: [...colorPropertiesLines],
    plotOptions: {
        line: {
            
        }
    },
    dataLabels: {
      //enabled: props.widgetprop.props.extended.dataLabels_enabled
    },
    xaxis: {
        type: 'datetime',//'datetime',
        //tickAmount: seriesConsumed[0]?.data.length-1,
        tickPlacement:'between',
        tooltip: {
            enabled: false
        },
        axisBorder: {
            show: true,
            color: 'var(--axis-color)',
        },
        axisTicks: {
            show: true,
            height: 3,
            color: 'var(--axis-color)',
        },
        labels: {
            show: true,
            style: {
                colors: 'red',
                fontSize: 14,
                fontFamily: "Roboto",
                //fontWeight: props.widgetprop.props.extended.fontweight,
            },
            /*formatter: function(value, timestamp, opts) {
                if (isNaN(value)) {
                    return 'Nopes';
                }
                var index = opts?.i;
                var thistimestamp = index!== undefined? opts.w.config.series[0].data[index]?.x:'';
                if(thistimestamp!== undefined && thistimestamp!==null && thistimestamp!==''){
                    var currentformatteddate = new Date(thistimestamp);
                    var currxvalue = '';
                    var options = { timeZone: "Asia/Kolkata" };
                    
                    switch (dateformatselected) {
                        case 'This Year':
                        case 'Last Year':
                            currxvalue = currentformatteddate.toLocaleDateString('en-us', { ...options, month: "short" });
                            break;
                        case 'This Month':
                        case 'Last Month':
                        case 'Last 30 days':
                            currxvalue = currentformatteddate.toLocaleDateString('en-us', { ...options, day: "numeric" });
                            break;
                        case 'This Week':
                        case 'Last Week':
                        case 'Last 7 days':
                            currxvalue = currentformatteddate.toLocaleDateString('en-us', { ...options, weekday: "short" });
                            break;
                        case 'Today':
                        case 'Yesterday':
                        case 'Last 24 hours':
                            currxvalue = currentformatteddate.toLocaleDateString('en-us', { ...options, hour: "numeric" });
                            break;
                        case 'Custom':
                            if (seriesConsumed[0]?.data.length > 30) {
                                currxvalue = (currentformatteddate.getDate() === 1) 
                                    ? currentformatteddate.toLocaleDateString('en-us', { ...options, day: "numeric", month: "short" }) 
                                    : '.';
                            } else {
                                currxvalue = currentformatteddate.toLocaleDateString('en-us', { ...options, day: "numeric" });
                            }
                            break;
                        default:
                            currxvalue = '';
                            break;
                    }
                    return currxvalue || '';
                }
                    
            }*/  
        },
        /*categories: categories,*/
    },
    //yaxis: yaxisProperties,
    tooltip: {
        enabled: true,
        enabledOnSeries: undefined,
        custom: function({ series, seriesIndex, dataPointIndex, w }) {
            const value = series[seriesIndex][dataPointIndex];
            const timestamp = w.globals.seriesX[seriesIndex][dataPointIndex];
        
            var currentFormattedDate = new Date(timestamp);
            var formattedDate = currentFormattedDate.toLocaleDateString('en-us', { timeZone: "Asia/kolkata", day: "numeric", month: "short" });
            
            // Begin building the tooltip string
            var tooltipString = `<div style="display:flex; flex-direction:column; padding:5px;">`;
            tooltipString += `<div style="font-weight:600;">${formattedDate}</div>`;
            for (var i = 0; i < series.length; i++) {
              const seriesValue = series[i][dataPointIndex];
              {/*tooltipString += `
                <div style="display:flex; align-items:center; margin-bottom:4px;">
                  <div style="height:8px; width:8px; background-color:${w.config.colors[i]}; border-radius:50%; margin-right:8px;"></div>
                  <div style="font-weight:600;">${seriesConsumed[i].name}</div>
                  <div style="margin-left:12px;">${seriesValue}</div>
                </div>
              `;*/}
            }
        
            tooltipString += `</div>`;
            return tooltipString;
          },
        
        hideEmptySeries: true,
        fillSeriesColor: false,
        theme: false,
        borderRadius:0,
        style: {
          fontSize: "12px",
          fontWeight: 800,
          fontFamily: 'Roboto',
        },
      },
    legend: {
        show: true,
        //fontSize: props.widgetprop.props.extended.legend.fontsize,
        //fontFamily: props.widgetprop.props.extended.legend.fontfamily,
        //fontWeight: props.widgetprop.props.extended.legend.fontweight,
        labels: {
            //colors: Array(colorPropertiesLines.length).fill('var(--legend-text-color)')
        },
        //customLegendItems: [...legendNamePropertiesLines],
        markers: {
            //radius: props.widgetprop.props.extended.legend.marker.radius,
            //height: props.widgetprop.props.extended.legend.marker.height,
            //width: props.widgetprop.props.extended.legend.marker.width,
            //fillColors: [...colorPropertiesLines]
        }
    },
};



export default function Linechartcard (props) {
    
    const [tagporpslist, setTagpropslist] = useState([])
    const [editorseries, setEditorseries] = useState([])
    const [chartoptions, setChartoption] = useState(linechartoptions)

    const series = [{
        name: "Deta",
        data: [{x:new Date('2018-02-12').getTime() , y: 10}, {x:new Date('2018-02-13').getTime() , y: 41}, {x:new Date('2018-02-14').getTime() , y: 35}, {x:new Date('2018-02-15').getTime() , y: 51}, {x:new Date('2018-02-16').getTime() , y: 49}, {x:new Date('2018-02-17').getTime() , y: 62}, {x:new Date('2018-02-18').getTime() , y: 69}, {x:new Date('2018-02-19').getTime() , y: 91}, {x:new Date('2018-02-20').getTime() , y: 148}]
    }]

    useEffect(() => {
        if(props.extendedprops !== undefined) {
            if(props.extendedprops.hasOwnProperty("tagpropslist")) {
                setTagpropslist(props.extendedprops.tagpropslist)
                var seriesdata = []
                for(let i=0; i<props.extendedprops.tagpropslist.length; i++) {
                    seriesdata.push({
                        name: props.extendedprops.tagpropslist[i].discription,
                        data: [{x:new Date('2018-02-12').getTime() , y: 10*(i+1)}, {x:new Date('2018-02-13').getTime() , y: 41*(i+1)}, {x:new Date('2018-02-14').getTime() , y: 35*(i+1)}, {x:new Date('2018-02-15').getTime() , y: 51*(i+1)}, {x:new Date('2018-02-16').getTime() , y: 49*(i+1)}, {x:new Date('2018-02-17').getTime() , y: 62*(i+1)}, {x:new Date('2018-02-18').getTime() , y: 69*(i+1)}, {x:new Date('2018-02-19').getTime() , y: 91*(i+1)}, {x:new Date('2018-02-20').getTime() , y: 148*(i+1)}],
                        color: props.extendedprops.tagpropslist[i].textcolor
                    })
                }
                var chartpro = {...chartoptions}
                //var chartpro = Object.assign({}, chartoptions)
                chartpro.xaxis.labels.style.fontSize = props.extendedprops.font.fontsize
                chartpro.xaxis.labels.style.fontFamily = props.extendedprops.font.fonttype
                chartpro.xaxis.labels.style.colors = props.extendedprops.font.color
                console.log("chartpro ", chartpro)
                
                setChartoption(chartoptions => ({
                    ...chartoptions,
                    ...chartpro
                }))
                console.log("chartoptions ",chartoptions)
                setEditorseries(seriesdata)
            }
        }
        //console.log("tagporpslist ",props.extendedprops.tagpropslist)
    },[props.extendedprops])


    return(
        <div style={{height: 'calc(100% - 55px)', width: 'calc(100% - 15px)', padding: '10px', overflow: 'auto'}}>
            <Chart options={chartoptions} series={editorseries} type='line' height="85%" width="100%" />
        </div>
        
    )
}